/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace dvs_ui
{
   import DvsPortMirroringSourcePorts =
         com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringSourcePorts;

   export class DvsPortMirroringSourcesViewComponent {
      public bindings:any;
      public controller:any;
      public templateUrl:string;

      constructor() {
         this.bindings = {
            selectedSession: "<",
            shouldRefresh: "<",
            onRefresh: "<"
         };
         this.controller = DvsPortMirroringSourcesViewController;
         this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
         "dvsPortMirroringSourcesDestViewTemplate.html";
      }
   }

   class DvsPortMirroringSourcesViewController {

      static $inject:any = [
         "i18nService",
         "$rootScope",
         "$scope",
         "vuiConstants",
         "columnRenderersRegistry",
         "networkUtil",
         "dvsPortMirroringSourcesAndDestRefreshService"
      ];

      public selectedSession: string;

      public shouldRefresh: boolean;

      public onRefresh: Function;

      public tableEntries: any;

      public datagridOptions: any;

      public liveRefreshProperties: string[];

      public dSwitchUri :string;

      constructor(private i18nService: any,
                  private $rootScope: any,
                  private $scope: any,
                  private vuiConstants: any,
                  private columnRenderersRegistry: any,
                  private networkUtil: any,
                  private dvsPortMirroringSourcesAndDestRefreshService: any) {

         this.createDatagridOptions();
      }

      public $onInit():void {
         this.datagridOptions.data = this.tableEntries;
         this.createDatagridOptions();
      }

      public $onChanges():void {
         if (this.shouldRefresh) {
            this.dvsPortMirroringSourcesAndDestRefreshService
                  .refreshDvsPortMirroringSourcesView(
                        this.$scope, this.$rootScope,
                        this.selectedSession, this.fillTableEntries.bind(this));

            this.dSwitchUri = this.$rootScope._route.objectId;
            this.liveRefreshProperties = [
                  "config.vspanSession"
            ];
         }
      }

      public fillTableEntries(detailsData:DvsPortMirroringSourcePorts) {
         if (detailsData) {
            this.tableEntries = detailsData.sourcePortData ?
                  detailsData.sourcePortData : [];
            this.sortEntities();
         } else {
            this.datagridOptions.data = [];
         }
         this.$scope.portMirrorLoading = false;
         this.onRefresh();
      }

      private sortEntities() {
         let sortedEntries:any = [];
         if (this.tableEntries) {
            sortedEntries = this.tableEntries.sort(
                  (item1:any, item2:any):any => {
                     return this.networkUtil.compareNumericAndNonNumericValues(
                           item1, item2, "portKey");
                  }
            );
         }
         this.datagridOptions.data = sortedEntries;
      }

      private createDatagridOptions():void {
         this.datagridOptions = {
            columnDefs: this.createColumnDefinitions(),
            sortMode: this.vuiConstants.grid.sortMode.SINGLE,
            selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            data: this.tableEntries,
            resizable: true,
            height: "100%",
            pageConfig: {
               hidePager: true
            }
         };
      }

      private createColumnDefinitions():any {

         let columnRenderer:any = this.columnRenderersRegistry
               .getColumnRenderer("object-link");

         return [{
            displayName: this.i18nService.getString(
                  "DvsUi", "SessionDvPortSourceList.port"),
            field: "portKey",
            width: "150px",
            sortable: (item1: any, item2: any) => {
               return this.networkUtil.compareNumericAndNonNumericValues(
                     item1, item2, "portKey");
            }
         },
            {
               displayName: this.i18nService.getString(
                     "DvsUi", "SessionDvPortSourceList.host"),
               field: "hostProxyName",
               width: "150px",
               template: (data:any) => {
                  return columnRenderer([undefined, "hostProxyName",
                     data.hostIcon], data);
               }
            },
            {
               displayName: this.i18nService.getString(
                     "DvsUi", "SessionDvPortSourceList.connectee"),
               field: "connectedEntityName",
               width: "150px",
               template: (data:any) => {
                  return columnRenderer([undefined, "connectedEntityName",
                     data.connecteeIconId], data);
               }
            },
            {
               displayName: this.i18nService.getString(
                     "DvsUi", "SessionDvPortSourceList.direction"),
               field: "trafficDirection",
               width: "150px",
               template: (data:any) => {
                  return columnRenderer([undefined, "trafficDirection",
                     data.trafficDirectionIconId], data);
               }
            }];
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .component("dvsPortMirroringSourcesView",
         new DvsPortMirroringSourcesViewComponent());
}
